import { useEffect, useMemo, useContext } from 'react';
import debounce from 'lodash.debounce';
import BrowserContext from '../../contexts/BrowserContext';
import ProductPageContext from '../../contexts/ProductPageContext';

function useSetupCrsOmni(omniWrapperRef) {
  const isBrowser = useContext(BrowserContext);
  const ProductPageState = useContext(ProductPageContext);
  const event = useMemo(() => isBrowser && new CustomEvent('omni-mfe-setup-crs-widget'), [isBrowser]);

  useEffect(() => {
    if ((!omniWrapperRef || omniWrapperRef?.children?.length === 0) && isBrowser) {
      window.dispatchEvent(event);
    }
  }, [omniWrapperRef, event, isBrowser]);

  const debouncedSetDigitalData = useMemo(() => debounce((qualifiedSku, productId) => {
    if (isBrowser && window.digitalData) {
      window.digitalData.set('pdp.omniMfeCrsDataBridge', {
        qualifiedSku,
        productId,
      });
    }
  }, 50), [isBrowser]);

  useEffect(() => {
    debouncedSetDigitalData(ProductPageState.collectionData.qualifiedSku, ProductPageState.productId);

    // Cleanup the debounced function on unmount or dependency change
    return () => {
      debouncedSetDigitalData.cancel();
    };
  }, [ProductPageState.collectionData.qualifiedSku, ProductPageState.productId, debouncedSetDigitalData]);
}

export default useSetupCrsOmni;
